import {Bubble, mixins} from 'vue-chartjs'

export default({
  extends: Bubble,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  
  mounted () {
    // console.log('xx', this.data, this.datacollection, this.chartData);
    this.renderChart(this.chartData, this.options);
  }
})


// WEBPACK FOOTER //
// ./src/components/BubbleChart.js